import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'label-create-route',
    templateUrl: './label-create-route.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LabelCreateRouteComponent {

  constructor() {
  }
}
